import cx from 'classnames';

type Props = {
    link: string;
    children?: React.ReactElement;
    className?: string;
    underlined?: boolean;
} & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const ExternalLink: React.FC<Props> = ({link, children, className, underlined}: Props) => (
    <a href={link} className={cx(className, 'tw-text-primary', {'tw-underline': underlined})} target='_blank' rel='noopener noreferrer'>
        {children || link}
    </a>
);